import { render, staticRenderFns } from "./TranUserPackageActivityReminderList.vue?vue&type=template&id=9f71edd2&scoped=true"
import script from "./TranUserPackageActivityReminderList.vue?vue&type=script&lang=js"
export * from "./TranUserPackageActivityReminderList.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageActivityReminderList.vue?vue&type=style&index=0&id=9f71edd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71edd2",
  null
  
)

export default component.exports